// import { useState, useEffect, useCallback } from 'react';
// import ReactDOM from 'react-dom';
// import {
//   FiRefreshCw, FiSearch, FiExternalLink, FiList,
//   FiCheckCircle, FiClock, FiAlertCircle, FiHash, FiFileText,
// } from 'react-icons/fi';
// import { getVendorInvoices, getInvoiceDocument } from '../../utils/ocrApi';

// // ── Document preview overlay (portal) ────────────────────────────────────────
// const DocumentPreviewOverlay = ({ invoiceNumber, url, expiresInMinutes, onClose }) => {
//   useEffect(() => {
//     const onKey = (e) => { if (e.key === 'Escape') onClose(); };
//     window.addEventListener('keydown', onKey);
//     return () => window.removeEventListener('keydown', onKey);
//   }, [onClose]);

//   return ReactDOM.createPortal(
//     <div className="document-preview-overlay" onClick={onClose}>
//       <div className="document-preview-sheet" onClick={(e) => e.stopPropagation()}>
//         <div className="document-preview-header">
//           <h4>Document Preview{invoiceNumber ? ` — ${invoiceNumber}` : ''}</h4>
//           <div className="document-preview-actions">
//             <span className="document-preview-hint">Esc</span>
//             <a href={url} target="_blank" rel="noopener noreferrer" className="document-preview-open-tab">
//               <FiExternalLink size={13} /> Open in New Tab
//             </a>
//             <button className="document-preview-close" onClick={onClose}>×</button>
//           </div>
//         </div>
//         <div className="document-preview-meta">
//           {expiresInMinutes
//             ? `Secure link · expires in ${expiresInMinutes} minutes.`
//             : 'Secure document link generated for preview.'}
//         </div>
//         <div className="document-preview-frame-wrap">
//           <iframe src={url} title="Invoice document preview" className="document-preview-frame" />
//         </div>
//       </div>
//     </div>,
//     document.body
//   );
// };

// // ── Status pill ───────────────────────────────────────────────────────────────
// function StatusPill({ status }) {
//   const s = (status || '').toLowerCase();
//   let cls = 'muted', icon = null, label = status || '—';

//   if (s === 'success' || s === 'posted' || s === 'approved') {
//     cls = 'success'; icon = <FiCheckCircle size={11} />;
//   } else if (s.includes('pending') || s === 'under review') {
//     cls = 'warn'; icon = <FiClock size={11} />;
//   } else if (s === 'rejected' || s === 'failed' || s === 'error') {
//     cls = 'danger'; icon = <FiAlertCircle size={11} />;
//   } else if (s === 'processing' || s === 'in progress') {
//     cls = 'info'; icon = <FiRefreshCw size={11} />;
//   }

//   return (
//     <span className={`inv-badge ${cls}`} style={{ textTransform: 'capitalize' }}>
//       {icon}{label}
//     </span>
//   );
// }

// // ── Main Component ────────────────────────────────────────────────────────────
// const OCRUploadedInvoices = () => {
//   const vendorCode = localStorage.getItem('vendorCode') || '';

//   const [invoices,   setInvoices]   = useState([]);
//   const [loading,    setLoading]    = useState(false);
//   const [error,      setError]      = useState('');
//   const [search,     setSearch]     = useState('');
//   const [lastFetch,  setLastFetch]  = useState(null);

//   // document preview state
//   const [loadingDoc, setLoadingDoc] = useState(null);   // invoice_number being fetched
//   const [docError,   setDocError]   = useState('');
//   const [preview,    setPreview]    = useState(null);   // { invoiceNumber, url, expiresIn }

//   const fetchInvoices = useCallback(async () => {
//     if (!vendorCode) { setError('Vendor code not found. Please log in again.'); return; }
//     setLoading(true); setError('');
//     try {
//       const data = await getVendorInvoices(vendorCode);
//       setInvoices(Array.isArray(data.invoices) ? data.invoices : []);
//       setLastFetch(new Date());
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   }, [vendorCode]);

//   useEffect(() => { fetchInvoices(); }, [fetchInvoices]);

//   const handleView = async (invoiceNumber) => {
//     if (loadingDoc) return;
//     setLoadingDoc(invoiceNumber);
//     setDocError('');
//     try {
//       const data = await getInvoiceDocument(invoiceNumber);
//       const url = data?.document_url || data?.url || data?.file_url || null;
//       if (!url) { setDocError(`No document available for ${invoiceNumber}.`); return; }
//       setPreview({
//         invoiceNumber,
//         url,
//         expiresIn: data?.expires_in_minutes ?? null,
//       });
//     } catch (err) {
//       setDocError(err.message);
//     } finally {
//       setLoadingDoc(null);
//     }
//   };

//   const filtered = invoices.filter((inv) => {
//     const q = search.toLowerCase();
//     return (
//       !q ||
//       (inv.invoice_number        || '').toLowerCase().includes(q) ||
//       (inv.purchase_order_number || '').toLowerCase().includes(q) ||
//       (inv.filename              || '').toLowerCase().includes(q) ||
//       (inv.sap_document_number   || '').toLowerCase().includes(q) ||
//       (inv.status                || '').toLowerCase().includes(q)
//     );
//   });

//   return (
//     <div>
//       {/* Header bar */}
//       <div style={{
//         display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//         marginBottom: 20, flexWrap: 'wrap', gap: 12,
//       }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//           <div style={{
//             width: 36, height: 36, borderRadius: 10,
//             background: 'linear-gradient(135deg,#0f4c81,#147699)',
//             display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
//           }}>
//             <FiList size={17} />
//           </div>
//           <div>
//             <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: '0.95rem', color: '#12213a' }}>
//               OCR Uploaded Invoices
//               {invoices.length > 0 && (
//                 <span style={{
//                   marginLeft: 8, background: 'linear-gradient(135deg,#e56e11,#fb923c)',
//                   color: '#fff', fontSize: '0.7rem', fontWeight: 800,
//                   padding: '2px 8px', borderRadius: 999,
//                 }}>
//                   {invoices.length}
//                 </span>
//               )}
//             </div>
//             {lastFetch && (
//               <div style={{ fontSize: '0.68rem', color: '#7a96b2', marginTop: 1 }}>
//                 Last updated {lastFetch.toLocaleTimeString()}
//               </div>
//             )}
//           </div>
//         </div>

//         <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
//           <div className="inv-filter-input" style={{ maxWidth: 280 }}>
//             <FiSearch size={14} />
//             <input
//               placeholder="Search invoices…"
//               value={search}
//               onChange={(e) => setSearch(e.target.value)}
//             />
//           </div>
//           <button
//             className="inv-btn ghost"
//             style={{ padding: '8px 14px', gap: 6 }}
//             onClick={fetchInvoices}
//             disabled={loading}
//           >
//             <FiRefreshCw size={14} style={loading ? { animation: 'inv-spin .7s linear infinite' } : {}} />
//             Refresh
//           </button>
//         </div>
//       </div>

//       {/* Vendor badge */}
//       {vendorCode && (
//         <div style={{
//           display: 'inline-flex', alignItems: 'center', gap: 6,
//           padding: '4px 12px', background: 'rgba(15,76,129,.07)',
//           border: '1px solid rgba(15,76,129,.18)', borderRadius: 999,
//           fontSize: '0.76rem', color: '#0f4c81', fontWeight: 700, marginBottom: 16,
//         }}>
//           <FiHash size={12} />
//           Vendor Code: {vendorCode}
//         </div>
//       )}

//       {/* Errors */}
//       {error && (
//         <div className="inv-error-banner">
//           <FiAlertCircle size={14} /> {error}
//         </div>
//       )}
//       {docError && (
//         <div className="inv-error-banner" style={{ marginBottom: 12 }}>
//           <FiAlertCircle size={14} /> {docError}
//         </div>
//       )}

//       {/* Loading skeleton */}
//       {loading && (
//         <div style={{
//           background: 'rgba(255,255,255,0.82)',
//           border: '1px solid rgba(216,227,240,0.8)',
//           borderRadius: 20, overflow: 'hidden',
//         }}>
//           {[...Array(5)].map((_, i) => (
//             <div key={i} style={{
//               display: 'flex', gap: 16, padding: '14px 20px',
//               borderBottom: i < 4 ? '1px solid rgba(216,227,240,.4)' : 'none',
//             }}>
//               {[120, 90, 110, 80, 180, 100, 90].map((w, j) => (
//                 <div key={j} style={{
//                   width: w, height: 14, borderRadius: 6,
//                   background: 'linear-gradient(90deg,#e8eff8 25%,#f5f8fc 50%,#e8eff8 75%)',
//                   backgroundSize: '600px 100%',
//                   animation: 'inv-shimmer 1.4s ease infinite',
//                   animationDelay: `${j * 60}ms`,
//                 }} />
//               ))}
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Table */}
//       {!loading && !error && (
//         filtered.length === 0 ? (
//           <div className="inv-card">
//             <div className="inv-empty">
//               <div className="inv-empty-icon"><FiList size={26} /></div>
//               <p>{search ? 'No invoices match your search.' : 'No uploaded invoices found for this vendor.'}</p>
//             </div>
//           </div>
//         ) : (
//           <div className="inv-card" style={{ padding: 0, overflow: 'hidden' }}>
//             <div className="inv-table-wrap" style={{ borderRadius: 0, border: 'none', boxShadow: 'none' }}>
//               <table className="inv-table">
//                 <thead>
//                   <tr>
//                     <th>Invoice #</th>
//                     <th>Date</th>
//                     <th>PO Number</th>
//                     <th>Total</th>
//                     <th>Filename</th>
//                     <th>SAP Doc #</th>
//                     <th>Status</th>
//                     <th style={{ textAlign: 'right' }}>Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {filtered.map((inv, i) => {
//                     const isLoadingThis = loadingDoc === inv.invoice_number;
//                     return (
//                       <tr key={inv.invoice_number || i} style={{ '--row-delay': `${i * 30}ms` }}>
//                         {/* Invoice # — clickable → opens document */}
//                         <td>
//                           <button
//                             onClick={() => handleView(inv.invoice_number)}
//                             disabled={!!loadingDoc}
//                             style={{
//                               background: 'none', border: 'none', padding: 0,
//                               color: '#0f4c81', fontWeight: 800, fontSize: '0.83rem',
//                               cursor: loadingDoc ? 'wait' : 'pointer',
//                               textDecoration: 'underline',
//                               textDecorationStyle: 'dotted', textUnderlineOffset: 3,
//                               fontFamily: 'inherit',
//                               display: 'flex', alignItems: 'center', gap: 5,
//                             }}
//                           >
//                             {isLoadingThis && <div className="inv-spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} />}
//                             {inv.invoice_number || '—'}
//                           </button>
//                         </td>

//                         <td style={{ color: '#4a6080', fontSize: '0.82rem' }}>{inv.invoice_date || '—'}</td>

//                         <td>
//                           <span style={{
//                             fontFamily: 'monospace', fontSize: '0.8rem',
//                             background: 'rgba(15,76,129,.07)', color: '#0f4c81',
//                             padding: '2px 7px', borderRadius: 5, fontWeight: 700,
//                           }}>
//                             {inv.purchase_order_number || '—'}
//                           </span>
//                         </td>

//                         <td style={{ fontWeight: 800, color: '#12213a' }}>
//                           {inv.invoice_total
//                             ? Number(inv.invoice_total).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
//                             : '—'}
//                         </td>

//                         <td style={{ fontSize: '0.8rem', color: '#4a6080', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                           <span title={inv.filename}>{inv.filename || '—'}</span>
//                         </td>

//                         <td>
//                           {inv.sap_document_number ? (
//                             <span style={{
//                               fontFamily: 'monospace', fontSize: '0.8rem',
//                               background: 'rgba(15,127,63,.08)', color: '#0f7f3f',
//                               padding: '2px 7px', borderRadius: 5, fontWeight: 700,
//                             }}>
//                               {inv.sap_document_number}
//                             </span>
//                           ) : (
//                             <span style={{ color: '#b0bec5', fontSize: '0.8rem' }}>—</span>
//                           )}
//                         </td>

//                         <td><StatusPill status={inv.status} /></td>

//                         {/* View button */}
//                         <td style={{ textAlign: 'right' }}>
//                           <button
//                             onClick={() => handleView(inv.invoice_number)}
//                             disabled={!!loadingDoc}
//                             style={{
//                               display: 'inline-flex', alignItems: 'center', gap: 5,
//                               background: 'none', border: 'none',
//                               cursor: loadingDoc ? 'wait' : 'pointer',
//                               color: isLoadingThis ? '#e56e11' : '#0f4c81',
//                               fontSize: '0.8rem', fontWeight: 700,
//                               padding: '4px 2px', fontFamily: 'inherit',
//                               transition: 'color .15s',
//                             }}
//                             onMouseEnter={(e) => { if (!loadingDoc) e.currentTarget.style.color = '#e56e11'; }}
//                             onMouseLeave={(e) => { if (!isLoadingThis) e.currentTarget.style.color = '#0f4c81'; }}
//                           >
//                             {isLoadingThis
//                               ? <><div className="inv-spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} /> Loading…</>
//                               : <><FiFileText size={13} /> View</>}
//                           </button>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             {/* Footer */}
//             <div style={{
//               padding: '10px 20px',
//               borderTop: '1px solid rgba(216,227,240,.5)',
//               background: 'rgba(239,246,255,.4)',
//               fontSize: '0.75rem', color: '#7a96b2', fontWeight: 600,
//               display: 'flex', alignItems: 'center', justifyContent: 'space-between',
//             }}>
//               <span>
//                 Showing {filtered.length} of {invoices.length} invoice{invoices.length !== 1 ? 's' : ''}
//                 {search && ` matching "${search}"`}
//               </span>
//               <span>
//                 {invoices.filter((inv) => (inv.status || '').toLowerCase() === 'success').length} successful
//               </span>
//             </div>
//           </div>
//         )
//       )}

//       {/* Document preview overlay */}
//       {preview && (
//         <DocumentPreviewOverlay
//           invoiceNumber={preview.invoiceNumber}
//           url={preview.url}
//           expiresInMinutes={preview.expiresIn}
//           onClose={() => setPreview(null)}
//         />
//       )}
//     </div>
//   );
// };

// export default OCRUploadedInvoices;


import { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import {
  FiRefreshCw, FiSearch, FiExternalLink, FiList,
  FiCheckCircle, FiClock, FiAlertCircle, FiHash, FiFileText,
} from 'react-icons/fi';
import { getVendorInvoices, getInvoiceDocument } from '../../utils/ocrApi';

// ── Document preview overlay (portal) ────────────────────────────────────────
const DocumentPreviewOverlay = ({ invoiceNumber, url, expiresInMinutes, onClose }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div className="document-preview-overlay" onClick={onClose}>
      <div className="document-preview-sheet" onClick={(e) => e.stopPropagation()}>
        <div className="document-preview-header">
          <h4>Document Preview{invoiceNumber ? ` — ${invoiceNumber}` : ''}</h4>
          <div className="document-preview-actions">
            <span className="document-preview-hint">Esc</span>
            <a href={url} target="_blank" rel="noopener noreferrer" className="document-preview-open-tab">
              <FiExternalLink size={13} /> Open in New Tab
            </a>
            <button className="document-preview-close" onClick={onClose}>×</button>
          </div>
        </div>
        <div className="document-preview-meta">
          {expiresInMinutes
            ? `Secure link · expires in ${expiresInMinutes} minutes.`
            : 'Secure document link generated for preview.'}
        </div>
        <div className="document-preview-frame-wrap">
          <iframe src={url} title="Invoice document preview" className="document-preview-frame" />
        </div>
      </div>
    </div>,
    document.body
  );
};

// ── Status pill ───────────────────────────────────────────────────────────────
function StatusPill({ status }) {
  const s = (status || '').toLowerCase();
  let cls = 'muted', icon = null, label = status || '—';

  if (s === 'success' || s === 'posted' || s === 'approved') {
    cls = 'success'; icon = <FiCheckCircle size={11} />;
  } else if (s.includes('pending') || s === 'under review') {
    cls = 'warn'; icon = <FiClock size={11} />;
  } else if (s === 'rejected' || s === 'failed' || s === 'error') {
    cls = 'danger'; icon = <FiAlertCircle size={11} />;
  } else if (s === 'processing' || s === 'in progress') {
    cls = 'info'; icon = <FiRefreshCw size={11} />;
  }

  return (
    <span className={`inv-badge ${cls}`} style={{ textTransform: 'capitalize' }}>
      {icon}{label}
    </span>
  );
}

// ── Main Component ────────────────────────────────────────────────────────────
const OCRUploadedInvoices = ({ refreshKey = 0 }) => {
  const vendorCode = localStorage.getItem('vendorCode') || '';

  const [invoices,   setInvoices]   = useState([]);
  const [loading,    setLoading]    = useState(false);
  const [error,      setError]      = useState('');
  const [search,     setSearch]     = useState('');
  const [lastFetch,  setLastFetch]  = useState(null);

  // document preview state
  const [loadingDoc, setLoadingDoc] = useState(null);   // invoice_number being fetched
  const [docError,   setDocError]   = useState('');
  const [preview,    setPreview]    = useState(null);   // { invoiceNumber, url, expiresIn }

  const fetchInvoices = useCallback(async () => {
    if (!vendorCode) { setError('Vendor code not found. Please log in again.'); return; }
    setLoading(true); setError('');
    try {
      const data = await getVendorInvoices(vendorCode);
      setInvoices(Array.isArray(data.invoices) ? data.invoices : []);
      setLastFetch(new Date());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  }, [vendorCode]);

  useEffect(() => { fetchInvoices(); }, [fetchInvoices, refreshKey]);

  const handleView = async (invoiceNumber) => {
    if (loadingDoc) return;
    setLoadingDoc(invoiceNumber);
    setDocError('');
    try {
      const data = await getInvoiceDocument(invoiceNumber);
      const url = data?.document_url || data?.url || data?.file_url || null;
      if (!url) { setDocError(`No document available for ${invoiceNumber}.`); return; }
      setPreview({
        invoiceNumber,
        url,
        expiresIn: data?.expires_in_minutes ?? null,
      });
    } catch (err) {
      setDocError(err.message);
    } finally {
      setLoadingDoc(null);
    }
  };

  const filtered = invoices.filter((inv) => {
    const q = search.toLowerCase();
    return (
      !q ||
      (inv.invoice_number        || '').toLowerCase().includes(q) ||
      (inv.purchase_order_number || '').toLowerCase().includes(q) ||
      (inv.filename              || '').toLowerCase().includes(q) ||
      (inv.sap_document_number   || '').toLowerCase().includes(q) ||
      (inv.status                || '').toLowerCase().includes(q)
    );
  });

  return (
    <div>
      {/* Header bar */}
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        marginBottom: 20, flexWrap: 'wrap', gap: 12,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 36, height: 36, borderRadius: 10,
            background: 'linear-gradient(135deg,#0f4c81,#147699)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff',
          }}>
            <FiList size={17} />
          </div>
          <div>
            <div style={{ fontFamily: "'Space Grotesk',sans-serif", fontWeight: 700, fontSize: '0.95rem', color: '#12213a' }}>
              OCR Uploaded Invoices
              {invoices.length > 0 && (
                <span style={{
                  marginLeft: 8, background: 'linear-gradient(135deg,#e56e11,#fb923c)',
                  color: '#fff', fontSize: '0.7rem', fontWeight: 800,
                  padding: '2px 8px', borderRadius: 999,
                }}>
                  {invoices.length}
                </span>
              )}
            </div>
            {lastFetch && (
              <div style={{ fontSize: '0.68rem', color: '#7a96b2', marginTop: 1 }}>
                Last updated {lastFetch.toLocaleTimeString()}
              </div>
            )}
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <div className="inv-filter-input" style={{ maxWidth: 280 }}>
            <FiSearch size={14} />
            <input
              placeholder="Search invoices…"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="inv-btn ghost"
            style={{ padding: '8px 14px', gap: 6 }}
            onClick={fetchInvoices}
            disabled={loading}
          >
            <FiRefreshCw size={14} style={loading ? { animation: 'inv-spin .7s linear infinite' } : {}} />
            Refresh
          </button>
        </div>
      </div>

      {/* Vendor badge */}
      {vendorCode && (
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '4px 12px', background: 'rgba(15,76,129,.07)',
          border: '1px solid rgba(15,76,129,.18)', borderRadius: 999,
          fontSize: '0.76rem', color: '#0f4c81', fontWeight: 700, marginBottom: 16,
        }}>
          <FiHash size={12} />
          Vendor Code: {vendorCode}
        </div>
      )}

      {/* Errors */}
      {error && (
        <div className="inv-error-banner">
          <FiAlertCircle size={14} /> {error}
        </div>
      )}
      {docError && (
        <div className="inv-error-banner" style={{ marginBottom: 12 }}>
          <FiAlertCircle size={14} /> {docError}
        </div>
      )}

      {/* Loading skeleton */}
      {loading && (
        <div style={{
          background: 'rgba(255,255,255,0.82)',
          border: '1px solid rgba(216,227,240,0.8)',
          borderRadius: 20, overflow: 'hidden',
        }}>
          {[...Array(5)].map((_, i) => (
            <div key={i} style={{
              display: 'flex', gap: 16, padding: '14px 20px',
              borderBottom: i < 4 ? '1px solid rgba(216,227,240,.4)' : 'none',
            }}>
              {[120, 90, 110, 80, 180, 100, 90].map((w, j) => (
                <div key={j} style={{
                  width: w, height: 14, borderRadius: 6,
                  background: 'linear-gradient(90deg,#e8eff8 25%,#f5f8fc 50%,#e8eff8 75%)',
                  backgroundSize: '600px 100%',
                  animation: 'inv-shimmer 1.4s ease infinite',
                  animationDelay: `${j * 60}ms`,
                }} />
              ))}
            </div>
          ))}
        </div>
      )}

      {/* Table */}
      {!loading && !error && (
        filtered.length === 0 ? (
          <div className="inv-card">
            <div className="inv-empty">
              <div className="inv-empty-icon"><FiList size={26} /></div>
              <p>{search ? 'No invoices match your search.' : 'No uploaded invoices found for this vendor.'}</p>
            </div>
          </div>
        ) : (
          <div className="inv-card" style={{ padding: 0, overflow: 'hidden' }}>
            <div className="inv-table-wrap" style={{ borderRadius: 0, border: 'none', boxShadow: 'none' }}>
              <table className="inv-table">
                <thead>
                  <tr>
                    <th>Invoice #</th>
                    <th>Date</th>
                    <th>PO Number</th>
                    <th>Total</th>
                    <th>Filename</th>
                    <th>SAP Doc #</th>
                    <th>Status</th>
                    <th style={{ textAlign: 'right' }}>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((inv, i) => {
                    const isLoadingThis = loadingDoc === inv.invoice_number;
                    return (
                      <tr key={inv.invoice_number || i} style={{ '--row-delay': `${i * 30}ms` }}>
                        {/* Invoice # — clickable → opens document */}
                        <td>
                          <button
                            onClick={() => handleView(inv.invoice_number)}
                            disabled={!!loadingDoc}
                            style={{
                              background: 'none', border: 'none', padding: 0,
                              color: '#0f4c81', fontWeight: 800, fontSize: '0.83rem',
                              cursor: loadingDoc ? 'wait' : 'pointer',
                              textDecoration: 'underline',
                              textDecorationStyle: 'dotted', textUnderlineOffset: 3,
                              fontFamily: 'inherit',
                              display: 'flex', alignItems: 'center', gap: 5,
                            }}
                          >
                            {isLoadingThis && <div className="inv-spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} />}
                            {inv.invoice_number || '—'}
                          </button>
                        </td>

                        <td style={{ color: '#4a6080', fontSize: '0.82rem' }}>{inv.invoice_date || '—'}</td>

                        <td>
                          <span style={{
                            fontFamily: 'monospace', fontSize: '0.8rem',
                            background: 'rgba(15,76,129,.07)', color: '#0f4c81',
                            padding: '2px 7px', borderRadius: 5, fontWeight: 700,
                          }}>
                            {inv.purchase_order_number || '—'}
                          </span>
                        </td>

                        <td style={{ fontWeight: 800, color: '#12213a' }}>
                          {inv.invoice_total
                            ? Number(inv.invoice_total).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : '—'}
                        </td>

                        <td style={{ fontSize: '0.8rem', color: '#4a6080', maxWidth: 200, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          <span title={inv.filename}>{inv.filename || '—'}</span>
                        </td>

                        <td>
                          {inv.sap_document_number ? (
                            <span style={{
                              fontFamily: 'monospace', fontSize: '0.8rem',
                              background: 'rgba(15,127,63,.08)', color: '#0f7f3f',
                              padding: '2px 7px', borderRadius: 5, fontWeight: 700,
                            }}>
                              {inv.sap_document_number}
                            </span>
                          ) : (
                            <span style={{ color: '#b0bec5', fontSize: '0.8rem' }}>—</span>
                          )}
                        </td>

                        <td><StatusPill status={inv.status} /></td>

                        {/* View button */}
                        <td style={{ textAlign: 'right' }}>
                          <button
                            onClick={() => handleView(inv.invoice_number)}
                            disabled={!!loadingDoc}
                            style={{
                              display: 'inline-flex', alignItems: 'center', gap: 5,
                              background: 'none', border: 'none',
                              cursor: loadingDoc ? 'wait' : 'pointer',
                              color: isLoadingThis ? '#e56e11' : '#0f4c81',
                              fontSize: '0.8rem', fontWeight: 700,
                              padding: '4px 2px', fontFamily: 'inherit',
                              transition: 'color .15s',
                            }}
                            onMouseEnter={(e) => { if (!loadingDoc) e.currentTarget.style.color = '#e56e11'; }}
                            onMouseLeave={(e) => { if (!isLoadingThis) e.currentTarget.style.color = '#0f4c81'; }}
                          >
                            {isLoadingThis
                              ? <><div className="inv-spinner" style={{ width: 12, height: 12, borderWidth: 1.5 }} /> Loading…</>
                              : <><FiFileText size={13} /> View</>}
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>

            {/* Footer */}
            <div style={{
              padding: '10px 20px',
              borderTop: '1px solid rgba(216,227,240,.5)',
              background: 'rgba(239,246,255,.4)',
              fontSize: '0.75rem', color: '#7a96b2', fontWeight: 600,
              display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
              <span>
                Showing {filtered.length} of {invoices.length} invoice{invoices.length !== 1 ? 's' : ''}
                {search && ` matching "${search}"`}
              </span>
              <span>
                {invoices.filter((inv) => (inv.status || '').toLowerCase() === 'success').length} successful
              </span>
            </div>
          </div>
        )
      )}

      {/* Document preview overlay */}
      {preview && (
        <DocumentPreviewOverlay
          invoiceNumber={preview.invoiceNumber}
          url={preview.url}
          expiresInMinutes={preview.expiresIn}
          onClose={() => setPreview(null)}
        />
      )}
    </div>
  );
};

export default OCRUploadedInvoices;
